var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductOnboardedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71429 19.7143C1.71429 21.132 2.868 22.2857 4.28571 22.2857H19.7143C21.132 22.2857 22.2857 21.132 22.2857 19.7143V6.85714H1.71429V19.7143ZM8.57143 8.57143H15.4286C15.9017 8.57143 16.2857 8.95457 16.2857 9.42857C16.2857 9.90257 15.9017 10.2857 15.4286 10.2857H8.57143C8.09829 10.2857 7.71429 9.90257 7.71429 9.42857C7.71429 8.95457 8.09829 8.57143 8.57143 8.57143ZM24 1.71429V3.42857C24 4.374 23.2311 5.14286 22.2857 5.14286H1.71429C0.768857 5.14286 0 4.374 0 3.42857V1.71429C0 0.768857 0.768857 0 1.71429 0H22.2857C23.2311 0 24 0.768857 24 1.71429Z",
    fill: "url(#paint0_linear_20_5413)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_5413",
    x1: 1.08874,
    y1: -6.4017e-9,
    x2: 21.1418,
    y2: 22.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD66FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A3B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductOnboardedIcon);
export default __webpack_public_path__ + "static/media/product-onboarded-icon.c2b199f9f5f109c4c55dad67ad019bc4.svg";
export { ForwardRef as ReactComponent };